import { NormalizeURLPath } from './functions';
import { PATH_MATCHER_PRIVATE } from './privates';
import { ConstructPathMatcher } from './constructor';
export function PathMatcherGetPath(instance) {
    return instance[PATH_MATCHER_PRIVATE].path;
}
export function PathMatcherExec(instance, path) {
    const privates = instance[PATH_MATCHER_PRIVATE];
    path = NormalizeURLPath(path);
    const match = privates.regExp.exec(path);
    if (match === null) {
        return null;
    }
    else {
        const params = new Map();
        for (let i = 0, l = match.length - 1; i < l; i++) {
            params.set(privates.params[i], match[i + 1]);
        }
        return Object.freeze({
            params,
            remaining: path.substring(match[0].length),
        });
    }
}
export class PathMatcher {
    constructor(path) {
        ConstructPathMatcher(this, path);
    }
    get path() {
        return PathMatcherGetPath(this);
    }
    exec(path) {
        return PathMatcherExec(this, path);
    }
}
//# sourceMappingURL=implementation.js.map